import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ThemedSwal } from "@/constants/themed-swal";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'GetStartedButton',
  props: {
    label: {}
  },
  setup(__props: any) {

const { t } = useI18n();

// eslint-disable-next-line no-undef


const showComingSoon = () => {
  ThemedSwal.fire({
    title: t("swals.app-coming-soon.title"),
    text: t("swals.app-coming-soon.description"),
    icon: "info",
    confirmButtonText: t("swals.app-coming-soon.confirm"),
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn bg-primary text-white rounded rounded-5 px-5",
    onClick: showComingSoon
  }, _toDisplayString(_ctx.label ?? _unref(t)("common.buttons.get-started")), 1))
}
}

})